import { cmsAxiosInstance } from '../configuration/axiosConfig';
import { ClientResponse } from '../model/ClientResponse';
import Oblast from '../model/Oblast';
import Otazka from '../model/Otazka';

const generatePathFromNazov = (nazov: string): string => {
  const lowercaseNazov = nazov.toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
  return lowercaseNazov.replace(/\s+/g, '-');
};

export const getNajcastejsieOtazky = async ():
  Promise<ClientResponse<Array<Oblast>>> => {
  const {
    data,
    status,
  } = await cmsAxiosInstance.get(
    '/najcastejsie-otazky/@nodes?limit=100',
  );

  const oblasti = data.filter(item => item.hasOwnProperty.call(item, 'otazky'));

  const mappedNajcastejsieOtazky = oblasti.map(responseItem => ({
    id: responseItem['@id'],
    nazov: responseItem.nazov,
    path: generatePathFromNazov(responseItem.nazov),
    otazky: Object.values(responseItem.otazky)
      .map((otazka: Otazka) => ({
        id: otazka['@id'],
        nazov: otazka.nazov,
        popis: otazka.popis,
        code: otazka['@name'],
      }))
      .filter((otazka: Otazka) => otazka.id),
    order: responseItem.otazky['@nodes'],
  }));

  return {
    data: mappedNajcastejsieOtazky,
    responseCode: status,
  };
};
